<template>
  <div class="card-tabs">
    <el-tabs v-model="localActiveTab" type="card" @tab-change="handleTabChange">
      <el-tab-pane
        v-for="item in examineItems"
        :key="item.examineItemCode"
        :label="item.examineItemName"
        :name="item.examineItemCode"
      >
        <div class="tab-content">
          <!-- 先处理所有child_list为空的元素，放在同一个row中 -->
          <el-row v-if="(item.child_list || []).filter(c => !c.child_list || c.child_list.length === 0).length > 0" :gutter="24" class="form-row">
            <el-col
              v-for="(child, childIndex) in (item.child_list || []).filter(c => !c.child_list || c.child_list.length === 0)"
              :key="childIndex"
              :span="6"
            >
              <el-form-item :label="child.examineItemName" :prop="child.examineItemCode">
                <template v-if="child.formShowType === 'input' || !child.formShowType">
                  <el-input
                    v-model="formData[child.examineItemCode]"
                    :placeholder="'请输入' + child.examineItemName"
                  >
                    <template v-if="child.examineItemUnit" slot="suffix">
                      {{ child.examineItemUnit }}
                    </template>
                  </el-input>
                </template>
                <template v-else-if="child.formShowType === 'textarea'">
                  <el-textarea
                    v-model="formData[child.examineItemCode]"
                    :placeholder="'请输入' + child.examineItemName"
                    :rows="3"
                  ></el-textarea>
                </template>
                <template v-else-if="child.formShowType === 'select'">
                      <el-select
                        v-model="formData[child.examineItemCode]"
                        :placeholder="'请选择' + child.examineItemName"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="option in (child.medicalDictType ? getDictOptions(child.medicalDictType) : (child.optionList || []))"
                          :key="option.dictCode || option.value"
                          :label="option.dictName || option.label"
                          :value="option.dictCode || option.value"
                        ></el-option>
                      </el-select>
                    </template>
                    <template v-else-if="child.formShowType === 'radio'">
                      <el-radio-group v-model="formData[child.examineItemCode]">
                        <el-radio
                          v-for="option in (child.medicalDictType ? getDictOptions(child.medicalDictType) : (child.optionList || []))"
                          :key="option.dictCode || option.value"
                          :label="option.dictName || option.label"
                        >{{ option.dictName || option.label }}</el-radio>
                      </el-radio-group>
                    </template>
                    <template v-else-if="child.formShowType === 'checkbox'">
                      <el-checkbox-group v-model="formData[child.examineItemCode]">
                        <el-checkbox
                          v-for="option in (child.medicalDictType ? getDictOptions(child.medicalDictType) : (child.optionList || []))"
                          :key="option.dictCode || option.value"
                          :label="option.dictName || option.label"
                          :value="option.dictCode || option.value"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </template>
                <template v-else-if="child.formShowType === 'dateTime'">
                  <el-date-picker
                    v-model="formData[child.examineItemCode]"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="'请选择' + child.examineItemName"
                    style="width: 100%"
                  ></el-date-picker>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 处理child_list不为空的元素（分组显示） -->
          <div v-for="(child, childIndex) in (item.child_list || []).filter(c => c.child_list && c.child_list.length > 0)" :key="childIndex" class="section">
            <!-- 分组标题 -->
            <div class="section-title">
              <span class="icon">◆◆</span>
              <span>{{ child.examineItemName }}</span>
            </div>

            <!-- 遍历二级子节点（实际的表单字段） -->
            <el-row :gutter="24" class="form-row">
              <el-col
                v-for="(field, fieldIndex) in child.child_list"
                :key="fieldIndex"
                :span="6"
              >
                <el-form-item :label="field.examineItemName" :prop="field.examineItemCode">
                  <template v-if="field.formShowType === 'input' || !field.formShowType">
                    <el-input
                      v-model="formData[field.examineItemCode]"
                      :placeholder="'请输入' + field.examineItemName"
                    >
                      <template v-if="field.examineItemUnit" slot="suffix">
                        {{ field.examineItemUnit }}
                      </template>
                    </el-input>
                  </template>
                  <template v-else-if="field.formShowType === 'textarea'">
                    <el-textarea
                      v-model="formData[field.examineItemCode]"
                      :placeholder="'请输入' + field.examineItemName"
                      :rows="3"
                    ></el-textarea>
                  </template>
                  <template v-else-if="field.formShowType === 'select'">
                    <el-select
                      v-model="formData[field.examineItemCode]"
                      :placeholder="'请选择' + field.examineItemName"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="option in (field.medicalDictType ? getDictOptions(field.medicalDictType) : (field.optionList || []))"
                        :key="option.dictCode || option.value"
                        :label="option.dictName || option.label"
                        :value="option.dictCode || option.value"
                      ></el-option>
                    </el-select>
                  </template>
                  <template v-else-if="field.formShowType === 'radio'">
                    <el-radio-group v-model="formData[field.examineItemCode]">
                      <el-radio
                        v-for="option in (field.medicalDictType ? getDictOptions(field.medicalDictType) : (field.optionList || []))"
                        :key="option.dictCode || option.value"
                        :label="option.dictName || option.label"
                      >{{ option.dictName || option.label }}</el-radio>
                    </el-radio-group>
                  </template>
                  <template v-else-if="field.formShowType === 'checkbox'">
                    <el-checkbox-group v-model="formData[field.examineItemCode]">
                      <el-checkbox
                        v-for="option in (field.medicalDictType ? getDictOptions(field.medicalDictType) : (field.optionList || []))"
                        :key="option.dictCode || option.value"
                        :label="option.dictName || option.label"
                        :value="option.dictCode || option.value"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </template>
                  <template v-else-if="field.formShowType === 'dateTime'">
                    <el-date-picker
                      v-model="formData[field.examineItemCode]"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :placeholder="'请选择' + field.examineItemName"
                      style="width: 100%"
                    ></el-date-picker>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: 'ExamineFormTabs',
  props: {
    examineItems: {
      type: Array,
      default: () => []
    },
    activeTab: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    medicalDicList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localActiveTab: this.activeTab
    }
  },
  watch: {
    activeTab(val) {
      this.localActiveTab = val
    }
  },
  methods: {
    getDictOptions(medicalDictType) {
      if (!medicalDictType || !this.medicalDicList || this.medicalDicList.length === 0) return []
      for (let item of this.medicalDicList) {
        if (item[medicalDictType]) {
          return item[medicalDictType]
        }
      }
      return []
    },
    handleTabChange(val) {
      this.$emit('update:activeTab', val)
    }
  }
}
</script>
<style scoped>
.card-tabs {
  flex: 1;
  min-height: 300px;
}

.section {
  margin-bottom: 24px;
}

.section-title {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #303133;
  margin-bottom: 16px;
  padding-left: 8px;
  border-left: 3px solid #409eff;
}

.section-title .icon {
  margin-right: 8px;
  font-size: 12px;
  color: #409eff;
}

.form-row {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/examine/examine-form-tabs.vue